import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const updateOrganization = async (options) => {
  const { token, userID, organizationID } = useCurrentUser();
  const apiURL = API_HOST + '/organizations/' + organizationID;
  
  try {
    const { data } = await axios.patch(apiURL, {organization: {...options}},{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
